export default async function loadLocaleData(locale: string): Promise<Record<string, any>> {
  switch (locale) {
    case "en-US":
      return import("../../lang/compiled/en-US.json");
    case "pt-BR":
    default:
      return import("../../lang/compiled/pt-BR.json");
  }
}
